module.exports = __webpack_public_path__ + "media/authors/kathryn-randolph-square-c8ec1615.jpg";